// extracted by mini-css-extract-plugin
module.exports =  {"unit":"var(--ring-unit)","version":"Version__version--bJ"};